import { defaultReturn, generateDefaultActions, makeWritePayload } from "shared-utility/store/utils/helpers";

export const SET_DSCR_CALC_SELECTIONS = generateDefaultActions("SET_DSCR_CALC_SELECTIONS");
export const setDscrCalculationDashboardSelections = payload => makeWritePayload(SET_DSCR_CALC_SELECTIONS.value, payload);

export const actionCreators = {
  setDscrCalculationDashboardSelections
};

const initialState = {
  isDeleteDialogOpen: false,
  isLenderReportingDrawerOpen: false,
  initialDrawerSectionName: null,
  totalDscrDebtService: 0,
  selectedLoanToEdit: null,
  loanIdToDeleteLineItemFrom: null,
  activeLoanId: null,
  goBackLink: null,
  wasContentUpdated: false
};

export function lenderReportsDscrCalculationReducer(state = initialState, action) {
  const { type, payload } = action;

  if(type === SET_DSCR_CALC_SELECTIONS.value){
    return defaultReturn({ ...state, ...payload });
  }
  return state;
};
